import { Box, Text } from '@chakra-ui/react'
import type { OfflineMapStatus } from '../../../hooks/useOfflineMapSave'

/** Small in-flow status pill (rendered through CanvasserMapView's `topStatus` slot): the map's offline save in progress / done. Silent for every other status. */
export function OfflineMapBadge({ status }: { status: OfflineMapStatus }) {
  const text = status === 'saving' ? 'Saving map for offline…' : status === 'saved' ? 'Map saved for offline ✓' : null
  return (
    <Box aria-live="polite" alignSelf="flex-start">
      {text && (
        <Box bg="surface" borderRadius="md" shadow="md" px={3} py={1.5}>
          <Text fontSize="xs" fontWeight="semibold" color="fg.muted">{text}</Text>
        </Box>
      )}
    </Box>
  )
}
